import React from 'react'
import { CapacityState } from 'services/metrics/types'

const MESSAGES: Record<CapacityState, React.ReactNode> = {
  empty:
    'Ele continuará sendo exibido enquanto houver horários recorrentes a serem ocupados, ou seja, quando o número de pacientes ativos for menor que o número de horários recorrentes.',
  below:
    'Ele continuará sendo exibido enquanto houver horários recorrentes a serem ocupados, ou seja, quando o número de pacientes ativos for menor que o número de horários recorrentes.',
  equal: (
    <>
      Você atingiu seu limite de pacientes de acordo com a quantidade de horários recorrentes
      cadastrados. Para voltarmos a priorizar seu perfil para novos pacientes,{' '}
      <strong>adicione novos horários recorrentes</strong>.
    </>
  ),
  above: (
    <>
      Para garantir que todos os pacientes sigam seu ciclo de cuidado, mantenha o número de
      pacientes ativos igual ou menor que o número de horários recorrentes.{' '}
      <strong>Adicione mais horários recorrentes</strong>.
    </>
  ),
}

interface Props {
  state: CapacityState;
}

export const CapacityMessage: React.FC<Props> = ({ state }) => <>{MESSAGES[state]}</>
